import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaPlus, FaBoxOpen } from 'react-icons/fa'
import { getAllOrders, createOrder } from '../../../store/actions/orders'
import OrderListItem from './OrderListItem'
import OrderDetails from './OrderDetails'
import OrderForm from './OrderForm'
import Container from './styles'

const Orders = () => {
  const dispatch = useDispatch()
  const orderData = useSelector((s) => s.OrderData || { data: [], pagination: {} })
  const orders = orderData.data || []
  const pagination = orderData.pagination || {}
  const loading = orderData.loading || false
  
  const [showForm, setShowForm] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [filter, setFilter] = useState('all')
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    dispatch(getAllOrders(1, 20))
  }, [dispatch])

  const handleSearch = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    dispatch(getAllOrders(1, 20, filter !== 'all' ? filter : '', value))
  }

  const handleFilterChange = (e) => {
    const status = e.target.value
    setFilter(status)
    dispatch(getAllOrders(1, 20, status !== 'all' ? status : '', searchTerm))
  }

  const handleOrderClick = (order) => {
    setSelectedOrder(order)
    setShowDetails(true)
  }

  const openForm = () => {
    setSelectedOrder(null)
    setShowForm(true)
  }

  const handleFormClose = () => {
    setShowForm(false)
    setSelectedOrder(null)
  }

  const handleDetailsClose = () => {
    setShowDetails(false)
    setSelectedOrder(null)
  }

  const handleFormSuccess = () => {
    setShowForm(false)
    dispatch(getAllOrders(1, 20, filter !== 'all' ? filter : '', searchTerm))
  }

  const filterOptions = [
    { value: 'all', label: 'All Orders' },
    { value: 'pending', label: 'Pending' },
    { value: 'assigned', label: 'Assigned' },
    { value: 'picked_up', label: 'Picked Up' },
    { value: 'in_transit', label: 'In Transit' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'cancelled', label: 'Cancelled' },
  ]

  const filteredOrders = orders.filter(order => {
    const matchesSearch = (order.trackingNumber || order.tracking_number || '')?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (order.customerName || order.customer_name || '')?.toLowerCase().includes(searchTerm.toLowerCase())
    return matchesSearch
  })

  return (
    <Container>
      <header>
        <div className="top--row">
          <h2>Orders Management</h2>
          <p className="subtitle">{orders.length} total orders</p>
        </div>
        <div className="header--row">
          <div className="filters">
            <select 
              value={filter} 
              onChange={handleFilterChange}
              className="filter-select"
            >
              {filterOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <input 
              type="search" 
              placeholder="Search orders..." 
              className="search-input"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <button className="add--btn" onClick={openForm}>
            <FaPlus className="icon" />
            <span>Create Order</span>
          </button>
        </div>
      </header>

      <div className="content--container">
        {loading ? (
          <div className="empty--container">
            <p>Loading orders...</p>
          </div>
        ) : filteredOrders.length === 0 ? (
          <div className="empty--container">
            <FaBoxOpen style={{ fontSize: '4rem', color: 'rgba(255, 255, 255, 0.3)' }} />
            <h3>No Orders Yet</h3>
            <p className="instruction">
              {searchTerm || filter !== 'all' 
                ? 'No orders match your search or filter'
                : 'Create your first order to start managing deliveries'}
            </p>
            {!searchTerm && filter === 'all' && (
              <button className="add--btn" onClick={openForm}>
                <FaPlus className="icon" />
                Create First Order
              </button>
            )}
          </div>
        ) : (
          <div className="orders--grid">
            {filteredOrders.map((order) => (
              <OrderListItem 
                key={order.id} 
                order={order} 
                onClick={() => handleOrderClick(order)}
              />
            ))}
          </div>
        )}
      </div>

      {showForm && (
        <OrderForm 
          showModal={showForm}
          onClose={handleFormClose}
          onSuccess={handleFormSuccess}
          editOrder={selectedOrder}
        />
      )}

      {showDetails && selectedOrder && (
        <OrderDetails 
          showModal={showDetails}
          onClose={handleDetailsClose}
          order={selectedOrder}
        />
      )}
    </Container>
  )
}

export default Orders
